import { API_BASE_URL } from "./constants/adminConstants";

export async function uploadToCloudinary(dataUrl, name = "") {
  const token = sessionStorage.getItem("tvc_token");
  if (!token) throw new Error("Authentication required");

  const res = await fetch(`${API_BASE_URL}/content/upload-image-base64`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ image: dataUrl, name }),
  });

  if (!res.ok) {
    const text = await res.text();
    console.error("[Upload] Server response", res.status, text);
    let errData, msg;
    try { errData = JSON.parse(text); msg = errData.detail || errData.error; } catch { msg = text; }
    throw new Error(msg || `Upload failed (HTTP ${res.status})`);
  }
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Upload failed");
  return data.url;
}
